<div class="header_wrap">
  <div class="nav_overlay" [ngClass]="{'sticky_nav': isSticky, 'hidden_nav': isHidden}">
    <div class="navbar">
      <div class="font_to_brand" (click)="toggleMenu()" [ngClass]="{'show': isMenuVisible}">
        <img src="assets/logo.png" alt="SHARKIFY.AI Logo" style="vertical-align: middle;" />
      </div>
      <!-- Desktop View -->
      <div class="laptop_view" style="justify-content: right;">
        <a class="header_menu_item" routerLink="/Home" (click)="scrollTo('HomeSection')">Home</a>
        <a class="header_menu_item" routerLink="/AboutUs">About Us</a>

        <!-- Features Dropdown -->
        <button  class="header_menu_item"  (click)="scrollTo('ExpertsIn')" style="border: none;">
          <a class="header_menu" (mouseenter)="showFeaturesMenu()" (mouseleave)="hideFeaturesMenu()" [matMenuTriggerFor]="featuresMenu"
            #featuresTrigger="matMenuTrigger">
            Services
        </a>
          <mat-menu #featuresMenu="matMenu" class="features-menu">
            <div class="menu-content" (mouseenter)="setHoverState(true)" (mouseleave)="setHoverState(false)">
              <button mat-menu-item *ngFor="let feature of features" [routerLink]="feature.link">
                {{ feature.name }}
              </button>
            </div>
          </mat-menu>
        </button>
        
        <a class="header_menu_item" routerLink="/Home">Blogs</a>
        <a class="header_menu_item" routerLink="/Home" (click)="scrollTo('SocialMediaPlans')">Plans</a>
        <a class="header_menu_item" routerLink="/ContactUs">Contact Us</a>
        <a class="header_menu_item" routerLink="/Login" style="margin-right: 50px;">Login</a>
      </div>

      <!-- Mobile View -->
      <div class="mobile_view">
        <div class="header_menu_dropdown">
          <button class="header_menu_dropbtn" style="border: none; background: none;">
            <mat-icon class="icon_display">view_headline</mat-icon>
          </button>
          <div class="header_menu_content">
            <a class="header_menu_item_for_mobile" routerLink="/Home" (click)="scrollTo('HomeSection')">Home</a>
            <a class="header_menu_item_for_mobile" routerLink="/AboutUs">About Us</a>
            <button mat-button class="header_menu_item_for_mobile"
              [matMenuTriggerFor]="featuresMenuMobile">Services</button>
            <mat-menu #featuresMenuMobile="matMenu">
              <button mat-menu-item *ngFor="let feature of features" [routerLink]="feature.link">
                {{ feature.name }}
              </button>
            </mat-menu>
            <a class="header_menu_item_for_mobile" routerLink="/Home" (click)="scrollTo('SocialMediaPlans')">Plans</a>
            <a class="header_menu_item_for_mobile" routerLink="/ContactUs">Contact Us</a>
            <a class="header_menu_item_for_mobile" routerLink="/Login">Login</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>